import { EyeSolidIcon } from './EyeSolid'
import { PauseSolidRoundedIcon } from './PauseSolidRounded'
import { PencilSolidIcon } from './PencilSolid'
import { TrashSolidIcon } from './TrashSolid'
import { StartSolidRoundedIcon } from './StartSolidRounded'
import { MagnifierIcon } from './Magnifier'
import { UserIcon } from './User'
import { UserRoundIcon } from './UserRound'
import { PaymentIcon } from './Payment'
import { ShutdownIcon } from './Shutdown'
import { CheckIcon } from './Check'
import { ErrorIcon } from './Error'
import { CopyIcon } from './Copy'
import { ChartIcon } from './Chart'
import { SitemapIcon } from './Sitemap'
import { ListIcon } from './List'
import { PlusIcon } from './Plus'
import { BullhornIcon } from './Bullhorn'
import { CodeIcon } from './Code'
import { BellIcon } from './Bell'
import { FlagIcon } from './Flag'
import { DevicesIcon } from './Devices'
import { BlocksIcon } from './Blocks'
import { FunnelIcon } from './Funnel'
import { TargetIcon } from './Target'
import { CalendarIcon } from './Calendar'
import { LevelsIcon } from './Levels'
import { BrowserIcon } from './Browser'
import { ImageIcon } from './Image'
import { DownloadIcon } from './Download'
import { CloseIcon } from './Close'
import { ChevronRightIcon, ChevronLeftIcon, ChevronUpIcon } from './Chevron'
import { FileIcon } from './File'
import { HourglassIcon } from './Hourglass'
import { ClockIcon } from './Clock'

// Grouped exports
export default {
  EyeSolidIcon,
  PauseSolidRoundedIcon,
  PencilSolidIcon,
  TrashSolidIcon,
  StartSolidRoundedIcon,
  MagnifierIcon,
  UserIcon,
  UserRoundIcon,
  PaymentIcon,
  ShutdownIcon,
  CheckIcon,
  ErrorIcon,
  CopyIcon,
  ChartIcon,
  SitemapIcon,
  ListIcon,
  PlusIcon,
  BullhornIcon,
  CodeIcon,
  BellIcon,
  FlagIcon,
  DevicesIcon,
  FunnelIcon,
  TargetIcon,
  BlocksIcon,
  CalendarIcon,
  LevelsIcon,
  BrowserIcon,
  ImageIcon,
  DownloadIcon,
  CloseIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  ChevronUpIcon,
  FileIcon,
  HourglassIcon,
  ClockIcon
}

// Module exports
export { EyeSolidIcon } from './EyeSolid'
export { PauseSolidRoundedIcon } from './PauseSolidRounded'
export { PencilSolidIcon } from './PencilSolid'
export { TrashSolidIcon } from './TrashSolid'
export { StartSolidRoundedIcon } from './StartSolidRounded'
export { MagnifierIcon } from './Magnifier'
export { UserIcon } from './User'
export { UserRoundIcon } from './UserRound'
export { PaymentIcon } from './Payment'
export { ShutdownIcon } from './Shutdown'
export { CheckIcon } from './Check'
export { ErrorIcon } from './Error'
export { CopyIcon } from './Copy'
export { ChartIcon } from './Chart'
export { SitemapIcon } from './Sitemap'
export { ListIcon } from './List'
export { PlusIcon } from './Plus'
export { BullhornIcon } from './Bullhorn'
export { CodeIcon } from './Code'
export { BellIcon } from './Bell'
export { FlagIcon } from './Flag'
export { DevicesIcon } from './Devices'
export { BlocksIcon } from './Blocks'
export { FunnelIcon } from './Funnel'
export { TargetIcon } from './Target'
export { CalendarIcon } from './Calendar'
export { LevelsIcon } from './Levels'
export { BrowserIcon } from './Browser'
export { ImageIcon } from './Image'
export { DownloadIcon } from './Download'
export { CloseIcon } from './Close'
export { ChevronRightIcon, ChevronLeftIcon, ChevronUpIcon } from './Chevron'
export { FileIcon } from './File'
export { HourglassIcon } from './Hourglass'
export { ClockIcon } from './Clock'